

class Email {

	isValid(email) {
		var regex = /\S+@\S+\.\S+/;
        return regex.test(email); 
	}
	
}

export default new Email();